/**
 * Класс для вспомогалтельных функций
 */
export default class Utils {
  // Функция проверит есть ли элемент на странице
  checkElement(selector, message = "Элемент не найден") {
    const elem = document.querySelector(selector);
    if (elem == undefined) {
      console.warn(message + " : " + selector);
      return false;
    } else {
      return elem;
    }
  }

  // Функция для удаления GET-параметра из URL
  removeQueryParam(get_param_name) {
    const urlObject = new URL(window.location.href);
    const params = new URLSearchParams(urlObject.search);

    params.delete(get_param_name);
    urlObject.search = params.toString();

    history.pushState({}, "", urlObject.toString());
  }

  /**
   * для мобилы переносим блок в мобильное меню
   * @param {*} where_selector - куда вставляем
   * @param {*} wich_selector - какой элемент вставляем
   * @returns
   */
  moveMobileParentBlock(where_selector, wich_selector) {
    if (
      780 < window.innerWidth ||
      !this.checkElement(where_selector) ||
      !this.checkElement(wich_selector)
    )
      return;

    document
      .querySelector(where_selector)
      .prepend(document.querySelector(wich_selector));
  }

  /**
   * Из за кривизны стилей для мобилы модалки добавляются в body
   * @param {*} selector
   * @param {*} elem
   */
  whereToAdd(selector, elem) {
    if (780 < window.innerWidth) {
      document.querySelector(selector).appendChild(elem);
    } else document.querySelector("body").appendChild(elem);
  }

  /**
   * Добавит стили для псевдотекста
   * @param {Array} styles - массив объектов [{selector:".elem-class", styles: [{name:"color","value":"red"}]}]
   */
  addPseudoTextStyle(elem_data) {
    const elem = document.createElement("style");

    let result = "";

    elem_data.forEach((elem) => {
      result +=
        elem.selector +
        ":after{" +
        elem.styles.reduce(
          (accum, style) => accum + style.name + ":'" + style.value + "';",
          ""
        ) +
        "}";
    });

    elem.textContent = result;

    document.head.appendChild(elem);
  }

  

}
